module.exports = "<div class=video-wrapper> <iframe src=\"https://player.vimeo.com/video/<%=videoId%>?autoplay=1\" title=\"<%=title%>\" frameborder=0 webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/cc/js/templates/vimeo.html
// module id = 671
// module chunks = 2 6